import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";

import { EmailFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkEmailPOSTErrorResponse, ParkEmailPOSTRequest, ParkEmailPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const sendByEmail = async (requestData: ParkEmailPOSTRequest): Promise<ParkEmailPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkEmailPOSTSuccessResponse>("/email", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkEmailPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: EmailFailReason };
  }
};
